import {useSelector} from 'react-redux'
import {ContentHotel} from '@findhotel/sapi'
import {LinksTabs} from 'components/Seo/LinksTabs'
import {usePlaceTopHotelsTab} from 'components/Seo/useLinksTabs'
import {useIsSrpSearchSeoFlow} from 'hooks/useIsSrpSearchSeoFlow'
import {getIsNoDatesSearch} from 'modules/search/selectors'
import {getAccommodationPageHotel} from 'modules/searchApi/selectors'
import {COUNTRY_TOP_HOTELS_LIMIT} from 'modules/seoApi/selectors'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'

/**
 * Place and country come from the hotel entity, not the breadcrumb, so the
 * block does not wait on a second seo-api round-trip.
 */
const ApTopHotelsTabs = ({hotel}: {hotel: ContentHotel}) => {
  const countryPlaceId = hotel.navPathInfo?.country?.id

  const placeTab = usePlaceTopHotelsTab(hotel.placeID, {
    excludedHotelId: hotel.objectID
  })
  const countryTab = usePlaceTopHotelsTab(countryPlaceId, {
    excludedHotelId: hotel.objectID,
    excludedLinks: placeTab?.links,
    limit: COUNTRY_TOP_HOTELS_LIMIT,
    skip: countryPlaceId === hotel.placeID
  })

  return <LinksTabs dataId="topHotelsLinks" tabs={[placeTab, countryTab]} />
}

/**
 * Top hotels block of the dateless SEO accommodation page
 */
export const ApTopHotelsLinks = () => {
  const hotel = useSelector(getAccommodationPageHotel)
  const isNoDatesSearch = useSelector(getIsNoDatesSearch)
  const isSrpSearchSeoFlow = useIsSrpSearchSeoFlow()
  const {search} = useBrandCapabilities()

  if (!search.hasSeoUrls || !isSrpSearchSeoFlow || !isNoDatesSearch || !hotel) {
    return null
  }

  return <ApTopHotelsTabs hotel={hotel} />
}
